import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'
import {TransitionGroup} from 'react-transition-group'
import MediaQuery from 'react-responsive'
import TaxTag from "./TaxTag";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/pro-light-svg-icons/faPlus";
import {faTimes} from "@fortawesome/pro-light-svg-icons/faTimes";
import ReactTooltip from 'react-tooltip'

class DomainActionButton extends Component {

    static propTypes = {
        animationInDelay: PropTypes.number,
        onClick: PropTypes.func,
        showSpinner: PropTypes.bool,
        label: PropTypes.any.isRequired,
        action: PropTypes.string
    }

    static defaultProps = {
        action: 'add'
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false
    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
    }

    componentWillEnter(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.from(dom, 0.2, {delay: this.props.animationInDelay, ease: Power3.easeOut, autoAlpha: 0, opacity: 0, scale: 0.8, onComplete: callback})
    }

    render() {
        switch (this.props.action) {
            case 'add':
                return (this.props.showSpinner) ?
                    <a href={'#'} onClick={this.props.onClick} className="add-domain disabled"><span className="spinner spinner--white"></span></a>
                    : <MediaQuery maxWidth={759}>{(isMatching) => {
                        return !isMatching ? <a href={'#'} onClick={this.props.onClick} className="add-domain">{this.props.label}</a> : <a href={'#'} onClick={this.props.onClick} className="add-domain">+</a>
                    }}</MediaQuery>
            case 'added':
                return <MediaQuery maxWidth={759}>{(isMatching) => {
                    return !isMatching ? <a href={'#'} onClick={this.props.onClick} className="add-domain disabled added">{this.props.label}</a> : <a href={'#'} onClick={this.props.onClick} className="add-domain disabled added">+</a>
                }}</MediaQuery>
            case 'remove':
                return (this.props.showSpinner) ?
                    <a href={'#'} onClick={this.props.onClick} className="remove-domain disabled"><span className="spinner spinner--white"></span></a>
                    : <MediaQuery maxWidth={759}>{(isMatching) => {
                        return !isMatching ? <a href={'#'} onClick={this.props.onClick} className="remove-domain">{this.props.label}</a> : <a href={'#'} onClick={this.props.onClick} className="remove-domain">-</a>
                    }}</MediaQuery>
            case 'removed':
                return <MediaQuery maxWidth={759}>{(isMatching) => {
                    return !isMatching ? <a href={'#'} onClick={this.props.onClick} className="remove-domain disabled removed">{this.props.label}</a> : <a href={'#'} onClick={this.props.onClick} className="remove-domain disabled removed">-</a>
                }}</MediaQuery>
            default:
                return null
        }
    }
}

class DomainListItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isGettingAddedToCart: false,
            showAddedToCart: false,
            isGettingRemovedFromCart: false,
            showRemovedFromCart: false
        }
    }

    static propTypes = {
        domainName: PropTypes.string.isRequired,
        domainEnding: PropTypes.string.isRequired,
        domainPriceSetup: PropTypes.string.isRequired,
        domainPriceMonthly: PropTypes.string.isRequired,
        uiState: PropTypes.string.isRequired,
        animationInDelay: PropTypes.number,
        onClick: PropTypes.func.isRequired,
        isGettingAddedToCart: PropTypes.bool,
        isGettingRemovedFromCart: PropTypes.bool,
        remainingInclusiveDomains: PropTypes.number
    }

    static defaultProps = {
        isAllowedAsInclusiveDomain: false,
        isGettingRemovedFromCart: false,
        isGettingAddedToCart: false,
        animationInDelay: 0,
        uiState: "",
    }

    componentWillAppear(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.from(dom, 0.65, {delay: this.props.animationInDelay, ease: Power3.easeOut, opacity: 0, onComplete: callback})
    }

    componentWillEnter(callback) {
        const dom = ReactDOM.findDOMNode(this)

        if (this.props.uiState === "added") {
            TweenLite.from(dom, 0.2, {delay: this.props.animationInDelay, ease: Power3.easeOut, opacity: 0, height: 0, minHeight: 0, onComplete: callback})
        } else {
            TweenLite.from(dom, 0.2, {delay: this.props.animationInDelay, ease: Power3.easeOut, opacity: 0, height: 0, minHeight: 0, onComplete: callback})
        }

    }

    componentWillLeave(callback) {

        if (this.state.isGettingAddedToCart) {

            this.setState({showAddedToCart: true})
            const dom = ReactDOM.findDOMNode(this)
            TweenLite.to(dom, 0.2, {delay: 0.25, ease: Power3.easeOut, opacity: 0, height: 0, minHeight: 0, onComplete: callback})

        } else if (this.state.isGettingRemovedFromCart) {

            this.setState({showRemovedFromCart: true})
            const dom = ReactDOM.findDOMNode(this)
            TweenLite.to(dom, 0.2, {delay: 0.25, ease: Power3.easeOut, opacity: 0, height: 0, minHeight: 0,  onComplete: callback})

        } else {

            callback()

        }

    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        // save the information that it got added to cart because the actual item wont be able to access new data once it leaves the parent transition group
        if (this.props.isGettingAddedToCart !== nextProps.isGettingAddedToCart) {
            this.setState({isGettingAddedToCart: true})
        }

        if (this.props.isGettingRemovedFromCart !== nextProps.isGettingRemovedFromCart) {
            this.setState({isGettingRemovedFromCart: true})
        }

        ReactTooltip.rebuild()

    }

    shouldComponentUpdate(prevProps, prevState) {
        if (this.props.isGettingAddedToCart !== prevProps.isGettingAddedToCart) {
            return true
        }
        if (this.state.showAddedToCart !== prevState.showAddedToCart) {
            return true
        }
        if (this.props.isGettingRemovedFromCart !== prevProps.isGettingRemovedFromCart) {
            return true
        }
        if (this.state.showRemovedFromCart !== prevState.showRemovedFromCart) {
            return true
        }
        if (this.props.domainName !== prevProps.domainName) {
            return true
        }
        if (this.props.domainEnding !== prevProps.domainEnding) {
            return true
        }
        if (this.props.uiState !== prevProps.uiState) {
            return true
        }
        if (this.props.domainPriceSetup !== prevProps.domainPriceSetup) {
            return true
        }
        if (this.props.domainPriceMonthly !== prevProps.domainPriceMonthly) {
            return true
        }
        if (this.props.remainingInclusiveDomains !== prevProps.remainingInclusiveDomains) {
            return true
        }
        return false
    }

    handleOnClick = (e) => {
        e.preventDefault();
        if (this.props.isGettingAddedToCart || this.props.isGettingRemovedFromCart || this.state.showAddedToCart || this.state.showRemovedFromCart) {
            return
        }

        this.props.onClick(e)

    }

    render() {

        return (
            <div className={"domain-listing__item--" + this.props.uiState + " domain-listing__item"}>
                <div>
                    <div className="domain-listing__item__title">{this.props.domainName}</div>
                    <span className="bold">{'.' + this.props.domainEnding}</span>
                    {this.props.remainingInclusiveDomains > 0 ? <div className="domain-listing__item__inclusive-domain">Als Inklusivdomain verfügbar (noch {this.props.remainingInclusiveDomains})</div> : null}
                </div>
                <div className={"domain-listing__item__price"}>{this.props.domainPriceSetup} €<br/><TaxTag key="tax"/></div>
                <div className={"domain-listing__item__price"}>{this.props.domainPriceMonthly} €<br/><TaxTag key="tax"/></div>
                {this.props.uiState === 'loading' ? <div className={"domain-listing__item__loading"}></div> : null}

                <TransitionGroup
                    component={(props) => {
                        return React.Children.toArray(props.children)[0] || null
                    }}
                >
                    {this.props.uiState === 'available' ?
                        <DomainActionButton
                            action={(this.state.showAddedToCart) ? "added" : "add"}
                            label={(<FontAwesomeIcon icon={faPlus}/>)}
                            showSpinner={this.props.isGettingAddedToCart}
                            animationInDelay={this.props.animationInDelay}
                            key="add-domain"
                            onClick={this.handleOnClick}
                        /> : null}
                    {this.props.uiState === 'added' ?
                        <DomainActionButton
                            action={(this.state.showRemovedFromCart) ? "removed" : "remove"}
                            label={(<FontAwesomeIcon icon={faTimes}/>)}
                            showSpinner={this.props.isGettingRemovedFromCart}
                            animationInDelay={this.props.animationInDelay}
                            key="remove-domain"
                            onClick={this.handleOnClick}
                        /> : null}
                </TransitionGroup>
                {this.props.uiState === 'gone' || this.props.uiState === 'gone-hide' ?
                    <div className="domain-listing__item__status">
                        <span>vergeben</span>
                        <div className={"tooltip-wrapper"}>
                            <a
                                data-for={"global"}
                                data-effect={"solid"}
                                data-place={"left"}
                                data-tip={"Deine Domain befindet sich noch bei dem alten Provider und du möchtest deine Website erst bei uns einrichten? Im Kundencenter hast du jederzeit die Möglichkeit, deine Domain umzuziehen."}
                            ></a>
                        </div>
                    </div> : null}
            </div>
        )
    }
}

export default DomainListItem



/** WEBPACK FOOTER **
 ** ./src/components/DomainListItem.js
 **/